import type {
  NavigationGuardReturn,
  RouteLocationNormalized,
} from "vue-router";

import { safeReturnPath } from "@/shared/lib";

/** Мінімум, який guard читає зі стору — для тестабельності без повного Pinia. */
export interface SessionGuardView {
  isAuthenticated: boolean;
}

/**
 * Чистий auth-guard (ADR-0006 D5) — `(to) => true | RouteLocationRaw`,
 * тестабельний без повного роутера:
 * - `requiresAuth` + анонім → `/login?return=<fullPath>`;
 * - `/login` + залогінений → `safeReturnPath(return)` (форму не показуємо);
 * - інакше → пропуск.
 *
 * Δ vue-router 3: повертаємо `true`/route-location замість виклику `next()`.
 */
export function createAuthGuard(session: SessionGuardView) {
  return (to: RouteLocationNormalized): NavigationGuardReturn => {
    if (to.meta.requiresAuth && !session.isAuthenticated) {
      return { name: "login", query: { return: to.fullPath } };
    }
    if (to.name === "login" && session.isAuthenticated) {
      return safeReturnPath(to.query.return);
    }
    return true;
  };
}
